/**
 * Security condition
 */
import {TUserRole} from '../constants';

export class SecurityCondition {

    /**
     * security condition is page for authenticated users
     */
    public static authenticated() {
        return {
            authenticated: true
        };
    }

    /**
     * security condition is it public page
     */
    public static anonymous() {
        return {
            publicPage: true
        };
    }

    /**
     * security condition is user has role
     * @param role - user role
     */
    public static hasRole(role: TUserRole[]) {
        return {
            hasRole: role
        };
    }

    /**
     * security condition is user has zone
     * @param zone - permission code zones
     */
    public static hasZone(zone: string[]) {
        return {
            hasZone: zone
        };
    }

    /**
     * security condition is user has role or zone
     * @param role - user role
     * @param zone - permission code zones
     */
    public static hasRoleOrZone(role: TUserRole[], zone: string[]) {
        return {
            hasRole: role,
            hasZone: zone
        };
    }

}
